import { BehaviorSubject } from "rxjs";

export const windowSizeChanged$: BehaviorSubject<any> = new BehaviorSubject('initialize');

export function isXsSizeScreen(): boolean {
    return screen.width < 600;
}

export function isSmSizeScreen(): boolean {
    return screen.width >= 600 && screen.width < 960;
}

export function isXsOrSmSizeScreen(): boolean {
    return isXsSizeScreen() || isSmSizeScreen();
}